/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChallengeEntitlementsControllerCheckAvailability200Response } from '../model';
// @ts-ignore
import type { CreateChallengeEntitlementDto } from '../model';
// @ts-ignore
import type { CreateMultipleChallengeEntitlementsDto } from '../model';
// @ts-ignore
import type { GetChallengeEntitlementResponseDto } from '../model';
// @ts-ignore
import type { PaginatedChallengeEntitlementsResponseDto } from '../model';
// @ts-ignore
import type { UpdateChallengeEntitlementDto } from '../model';
/**
 * ChallengeEntitlementsApi - axios parameter creator
 * @export
 */
export const ChallengeEntitlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check availability of a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {number} [quantity] Requested quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCheckAvailability: async (challengeCategoryId: string, id: string, quantity?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCheckAvailability', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCheckAvailability', 'id', id)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/{id}/availability`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (quantity !== undefined) {
                localVarQueryParameter['quantity'] = quantity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateChallengeEntitlementDto} createChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCreate: async (challengeCategoryId: string, createChallengeEntitlementDto: CreateChallengeEntitlementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCreate', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'createChallengeEntitlementDto' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCreate', 'createChallengeEntitlementDto', createChallengeEntitlementDto)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChallengeEntitlementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create multiple challenge entitlements
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCreateMultiple: async (challengeCategoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCreateMultiple', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'createMultipleChallengeEntitlementsDto' is not null or undefined
            assertParamExists('challengeEntitlementsControllerCreateMultiple', 'createMultipleChallengeEntitlementsDto', createMultipleChallengeEntitlementsDto)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/bulk`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMultipleChallengeEntitlementsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindAll: async (challengeCategoryId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerFindAll', 'challengeCategoryId', challengeCategoryId)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific challenge entitlement by ID
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindOne: async (challengeCategoryId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerFindOne', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('challengeEntitlementsControllerFindOne', 'id', id)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/{id}`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all optional entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindOptional: async (challengeCategoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerFindOptional', 'challengeCategoryId', challengeCategoryId)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/optional`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all required entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindRequired: async (challengeCategoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerFindRequired', 'challengeCategoryId', challengeCategoryId)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/required`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerRemove: async (challengeCategoryId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerRemove', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('challengeEntitlementsControllerRemove', 'id', id)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/{id}`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {UpdateChallengeEntitlementDto} updateChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerUpdate: async (challengeCategoryId: string, id: string, updateChallengeEntitlementDto: UpdateChallengeEntitlementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeCategoryId' is not null or undefined
            assertParamExists('challengeEntitlementsControllerUpdate', 'challengeCategoryId', challengeCategoryId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('challengeEntitlementsControllerUpdate', 'id', id)
            // verify required parameter 'updateChallengeEntitlementDto' is not null or undefined
            assertParamExists('challengeEntitlementsControllerUpdate', 'updateChallengeEntitlementDto', updateChallengeEntitlementDto)
            const localVarPath = `/api/challenge-categories/{challengeCategoryId}/entitlements/{id}`
                .replace(`{${"challengeCategoryId"}}`, encodeURIComponent(String(challengeCategoryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChallengeEntitlementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChallengeEntitlementsApi - functional programming interface
 * @export
 */
export const ChallengeEntitlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChallengeEntitlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check availability of a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {number} [quantity] Requested quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerCheckAvailability(challengeCategoryId: string, id: string, quantity?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengeEntitlementsControllerCheckAvailability200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerCheckAvailability(challengeCategoryId, id, quantity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerCheckAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateChallengeEntitlementDto} createChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerCreate(challengeCategoryId: string, createChallengeEntitlementDto: CreateChallengeEntitlementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChallengeEntitlementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerCreate(challengeCategoryId, createChallengeEntitlementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create multiple challenge entitlements
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerCreateMultiple(challengeCategoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChallengeEntitlementResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerCreateMultiple(challengeCategoryId, createMultipleChallengeEntitlementsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerCreateMultiple']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerFindAll(challengeCategoryId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedChallengeEntitlementsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerFindAll(challengeCategoryId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific challenge entitlement by ID
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerFindOne(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChallengeEntitlementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerFindOne(challengeCategoryId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all optional entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerFindOptional(challengeCategoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChallengeEntitlementResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerFindOptional(challengeCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerFindOptional']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all required entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerFindRequired(challengeCategoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChallengeEntitlementResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerFindRequired(challengeCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerFindRequired']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerRemove(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerRemove(challengeCategoryId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {UpdateChallengeEntitlementDto} updateChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeEntitlementsControllerUpdate(challengeCategoryId: string, id: string, updateChallengeEntitlementDto: UpdateChallengeEntitlementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChallengeEntitlementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeEntitlementsControllerUpdate(challengeCategoryId, id, updateChallengeEntitlementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeEntitlementsApi.challengeEntitlementsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChallengeEntitlementsApi - factory interface
 * @export
 */
export const ChallengeEntitlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChallengeEntitlementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Check availability of a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {number} [quantity] Requested quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCheckAvailability(challengeCategoryId: string, id: string, quantity?: number, options?: RawAxiosRequestConfig): AxiosPromise<ChallengeEntitlementsControllerCheckAvailability200Response> {
            return localVarFp.challengeEntitlementsControllerCheckAvailability(challengeCategoryId, id, quantity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateChallengeEntitlementDto} createChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCreate(challengeCategoryId: string, createChallengeEntitlementDto: CreateChallengeEntitlementDto, options?: RawAxiosRequestConfig): AxiosPromise<GetChallengeEntitlementResponseDto> {
            return localVarFp.challengeEntitlementsControllerCreate(challengeCategoryId, createChallengeEntitlementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create multiple challenge entitlements
         * @param {string} challengeCategoryId Challenge category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerCreateMultiple(challengeCategoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChallengeEntitlementResponseDto>> {
            return localVarFp.challengeEntitlementsControllerCreateMultiple(challengeCategoryId, createMultipleChallengeEntitlementsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindAll(challengeCategoryId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedChallengeEntitlementsResponseDto> {
            return localVarFp.challengeEntitlementsControllerFindAll(challengeCategoryId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific challenge entitlement by ID
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindOne(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetChallengeEntitlementResponseDto> {
            return localVarFp.challengeEntitlementsControllerFindOne(challengeCategoryId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all optional entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindOptional(challengeCategoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChallengeEntitlementResponseDto>> {
            return localVarFp.challengeEntitlementsControllerFindOptional(challengeCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all required entitlements for a challenge category
         * @param {string} challengeCategoryId Challenge category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerFindRequired(challengeCategoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChallengeEntitlementResponseDto>> {
            return localVarFp.challengeEntitlementsControllerFindRequired(challengeCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerRemove(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.challengeEntitlementsControllerRemove(challengeCategoryId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a challenge entitlement
         * @param {string} challengeCategoryId Challenge category ID
         * @param {string} id Challenge entitlement ID
         * @param {UpdateChallengeEntitlementDto} updateChallengeEntitlementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeEntitlementsControllerUpdate(challengeCategoryId: string, id: string, updateChallengeEntitlementDto: UpdateChallengeEntitlementDto, options?: RawAxiosRequestConfig): AxiosPromise<GetChallengeEntitlementResponseDto> {
            return localVarFp.challengeEntitlementsControllerUpdate(challengeCategoryId, id, updateChallengeEntitlementDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChallengeEntitlementsApi - object-oriented interface
 * @export
 * @class ChallengeEntitlementsApi
 * @extends {BaseAPI}
 */
export class ChallengeEntitlementsApi extends BaseAPI {
    /**
     * 
     * @summary Check availability of a challenge entitlement
     * @param {string} challengeCategoryId Challenge category ID
     * @param {string} id Challenge entitlement ID
     * @param {number} [quantity] Requested quantity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerCheckAvailability(challengeCategoryId: string, id: string, quantity?: number, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerCheckAvailability(challengeCategoryId, id, quantity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new challenge entitlement
     * @param {string} challengeCategoryId Challenge category ID
     * @param {CreateChallengeEntitlementDto} createChallengeEntitlementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerCreate(challengeCategoryId: string, createChallengeEntitlementDto: CreateChallengeEntitlementDto, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerCreate(challengeCategoryId, createChallengeEntitlementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create multiple challenge entitlements
     * @param {string} challengeCategoryId Challenge category ID
     * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerCreateMultiple(challengeCategoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerCreateMultiple(challengeCategoryId, createMultipleChallengeEntitlementsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all entitlements for a challenge category
     * @param {string} challengeCategoryId Challenge category ID
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerFindAll(challengeCategoryId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerFindAll(challengeCategoryId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific challenge entitlement by ID
     * @param {string} challengeCategoryId Challenge category ID
     * @param {string} id Challenge entitlement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerFindOne(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerFindOne(challengeCategoryId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all optional entitlements for a challenge category
     * @param {string} challengeCategoryId Challenge category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerFindOptional(challengeCategoryId: string, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerFindOptional(challengeCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all required entitlements for a challenge category
     * @param {string} challengeCategoryId Challenge category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerFindRequired(challengeCategoryId: string, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerFindRequired(challengeCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a challenge entitlement
     * @param {string} challengeCategoryId Challenge category ID
     * @param {string} id Challenge entitlement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerRemove(challengeCategoryId: string, id: string, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerRemove(challengeCategoryId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a challenge entitlement
     * @param {string} challengeCategoryId Challenge category ID
     * @param {string} id Challenge entitlement ID
     * @param {UpdateChallengeEntitlementDto} updateChallengeEntitlementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeEntitlementsApi
     */
    public challengeEntitlementsControllerUpdate(challengeCategoryId: string, id: string, updateChallengeEntitlementDto: UpdateChallengeEntitlementDto, options?: RawAxiosRequestConfig) {
        return ChallengeEntitlementsApiFp(this.configuration).challengeEntitlementsControllerUpdate(challengeCategoryId, id, updateChallengeEntitlementDto, options).then((request) => request(this.axios, this.basePath));
    }
}

